/**
 * Localization strings used in the Statistics Page
 *
 * @module
 */

import { createDictionary } from './utils';

// Refer to "Guidelines for Programmers" in ./README.md before editing this file

/* eslint-disable @typescript-eslint/naming-convention */
export const statsText = createDictionary({
  holdings: {
    'en-us': 'Holdings',
    'ru-ru': 'Холдинги',
    'es-es': 'Mantenimientos',
    'de-ch': 'Beteiligungen',
    'fr-fr': 'Participations',
    'pt-br': 'Participações',
    'uk-ua': 'Холдинги',
    'hr-hr': 'Udjeli',
    nb: 'Beholdning',
  },
  collectionObjects: {
    'en-us': 'Collection Objects',
    'ru-ru': 'Объекты коллекции',
    'es-es': 'Objetos de la Colección',
    'de-ch': 'Sammlungsobjekte',
    'fr-fr': 'Objets',
    'pt-br': 'Objetos da Coleção',
    'uk-ua': "Об'єкти колекції",
    'hr-hr': 'Objekti kolekcije',
    nb: 'Samlingsobjekter',
  },
  typeSpecimens: {
    'en-us': 'Type Specimens',
    'es-es': 'Especímenes Tipo',
    'de-ch': 'Typusexemplare',
    'fr-fr': 'Spécimens types',
    'pt-br': 'Espécimes-tipo',
    'ru-ru': 'Типовые образцы',
    'uk-ua': 'Типові зразки',
    'hr-hr': 'Tipični uzorci',
    nb: 'Typer',
  },
  curation: {
    'en-us': 'Curation',
    'es-es': 'Curación',
    'de-ch': 'Kuratierung',
    'fr-fr': 'Conservation',
    'pt-br': 'Curadoria',
    'ru-ru': 'Кураторство',
    'uk-ua': 'Кураторство',
    'hr-hr': 'Kuratorstvo',
    nb: 'Kuratering',
  },
  loans: {
    'en-us': 'Loans',
    'ru-ru': 'Заемы',
    'es-es': 'Préstamos',
    'de-ch': 'Kredite',
    'fr-fr': 'Prêts',
    'pt-br': 'Empréstimos',
    'uk-ua': 'Кредити',
    'hr-hr': 'Zajmovi',
    nb: 'Lån',
  },
  itemsOnLoans: {
    'en-us': 'Items on Loan',
    'ru-ru': 'Предметы в Займы',
    'es-es': 'Artículos en Préstamo',
    'de-ch': 'Leihgegenstände',
    'fr-fr': 'Objets prêtés',
    'pt-br': 'Itens emprestados',
    'uk-ua': 'Речі в оренду',
    'hr-hr': 'Predmeti na posudbu',
    nb: 'Utlånte objekter',
  },
  openLoansStat: {
    'en-us': 'Open Loans',
    'ru-ru': 'Открытые Займы',
    'es-es': 'Préstamos Abiertos',
    'de-ch': 'Offene Kredite',
    'fr-fr': 'Prêts ouverts',
    'pt-br': 'Empréstimos abertos',
    'uk-ua': 'Відкриті позики',
    'hr-hr': 'Otvoreni krediti',
    nb: 'Pågående lån',
  },
  overdueLoans: {
    'en-us': 'Overdue Loans',
    'ru-ru': 'Просроченные Займы',
    'es-es': 'Préstamos Atrasados',
    'de-ch': 'Überfällige Kredite',
    'fr-fr': 'Prêts en retards',
    'pt-br': 'Empréstimos em atraso',
    'uk-ua': 'Прострочені кредити',
    'hr-hr': 'Dospjeli krediti',
    nb: 'Forfalte lån',
  },
  localityGeography: {
    'en-us': 'Locality / Geography',
    'ru-ru': 'Местность / География',
    'es-es': 'Localidad / Geografía',
    'de-ch': 'Ort / Geographie',
    'fr-fr': 'Localité / Géographie',
    'pt-br': 'Localidade / Geografia',
    'uk-ua': 'Місцевість / Географія',
    'hr-hr': 'Lokalitet / Geografija',
    nb: 'Lokalitet / Geografi',
  },
  localities: {
    'en-us': 'Localities',
    'ru-ru': 'Местности',
    'es-es': 'Localidades',
    'de-ch': 'Ortschaften',
    'fr-fr': 'Localités',
    'pt-br': 'Localidades',
    'uk-ua': 'Населені пункти',
    'hr-hr': 'Lokaliteti',
    nb: 'Lokaliteter',
  },
  geographyEntries: {
    'en-us': 'Geography Entries',
    'ru-ru': 'География Записи',
    'es-es': 'Entradas de Geografía',
    'de-ch': 'Geographie-Einträge',
    'fr-fr': 'Entrées géographiques',
    'pt-br': 'Entradas de Geografia',
    'uk-ua': 'Географічні записи',
    'hr-hr': 'Geografski unosi',
    nb: 'Geografiske oppføringer',
  },
  countries: {
    'en-us': 'Countries',
    'ru-ru': 'Страны',
    'es-es': 'Países',
    'de-ch': 'Länder',
    'fr-fr': 'Pays',
    'pt-br': 'Países',
    'uk-ua': 'Країни',
    'hr-hr': 'Zemlje',
    nb: 'Land',
  },
  georeferencedLocalities: {
    'en-us': 'Georeferenced Localities',
    'ru-ru': 'Места с географической привязкой',
    'es-es': 'Localidades Georreferenciadas',
    'de-ch': 'Georeferenzierte Orte',
    'fr-fr': 'Localités géoréférencées',
    'pt-br': 'Localidades georreferenciadas',
    'uk-ua': "Геоприв'язані населені пункти",
    'hr-hr': 'Georeferencirani lokaliteti',
    nb: 'Lokaliteter med koordinater',
  },
  digitization: {
    'en-us': 'Digitization',
    'es-es': 'Digitalización',
    'de-ch': 'Digitalisierung',
    'fr-fr': 'Numérisation',
    'pt-br': 'Digitalização',
    'ru-ru': 'Оцифровка',
    'uk-ua': 'Оцифрування',
    'hr-hr': 'Digitalizacija',
    nb: 'Digitalisering',
  },
  digitizedLastSevenDays: {
    'en-us': 'Digitized Last 7 Days',
    'es-es': 'Digitalizado Últimos 7 Días',
    'de-ch': 'Digitalisiert in den letzten 7 Tagen',
    'fr-fr': 'Numérisé les 7 derniers jours',
    'pt-br': 'Últimos 7 dias digitalizados',
    'ru-ru': 'Оцифровано за последние 7 дней',
    'uk-ua': 'Оцифровано за останні 7 днів',
    'hr-hr': 'Digitalizirano posljednjih 7 dana',
    nb: 'Digitaliserte siste syv dager',
  },
  digitizedLastMonth: {
    'en-us': 'Digitized Last Month',
    'es-es': 'Digitalizado Último Mes',
    'de-ch': 'Im letzten Monat digitalisiert',
    'fr-fr': 'Numérisé le mois dernier',
    'pt-br': 'Digitalizado no mês passado',
    'ru-ru': 'Оцифровано в прошлом месяце',
    'uk-ua': 'Оцифровано минулого місяця',
    'hr-hr': 'Digitalizirano prošli mjesec',
    nb: 'Digitalisert forrige måned',
  },
  digitizedLastYear: {
    'en-us': 'Digitized Last Year',
    'es-es': 'Digitalizado Último Año',
    'de-ch': 'Letztes Jahr digitalisiert',
    'fr-fr': "Numérisé l'année dernière",
    'pt-br': 'Digitalizado no ano passado',
    'ru-ru': 'Оцифровано в прошлом году',
    'uk-ua': 'Оцифровано минулого року',
    'hr-hr': 'Digitalizirano prošle godine',
    nb: 'Digitalisert i fjor',
  },
  chooseStatistics: {
    'en-us': 'Choose Statistics',
    'ru-ru': 'Выберите статистику',
    'es-es': 'Seleccionar Estadísticas',
    'de-ch': 'Statistik auswählen',
    'fr-fr': 'Choisir les statistiques',
    'pt-br': 'Selecione Estatísticas',
    'uk-ua': 'Виберіть Статистику',
    'hr-hr': 'Odaberite Statistiku',
    nb: 'Velg statistikk',
  },
  selectFromQueries: {
    'en-us': 'Select From Queries',
    'es-es': 'Seleccionar de Consultas',
    'de-ch': 'Auswahl aus Abfragen',
    'fr-fr': 'Sélectionner parmi les requêtes',
    'pt-br': 'Selecionar a partir de consultas',
    'ru-ru': 'Выберите из запросов',
    'uk-ua': 'Вибрати з запитів',
    'hr-hr': 'Odaberite iz upita',
    nb: 'Velg fra avansert søk',
  },
  selectFromAvailableDefault: {
    'en-us': 'Select From Available Default Statistics',
    'es-es': 'Seleccionar de Estadísticas Predeterminadas Disponibles',
    'de-ch': 'Wählen Sie aus den verfügbaren Standardstatistiken aus',
    'fr-fr': 'Sélectionnez parmi les statistiques par défaut disponibles',
    'pt-br': 'Selecione entre as estatísticas padrão disponíveis',
    'ru-ru': 'Выберите из доступных статистических данных по умолчанию.',
    'uk-ua': 'Виберіть із доступної статистики за замовчуванням',
    'hr-hr': 'Odaberite iz dostupnih zadanih statistika',
    nb: 'Velg fra tilgjengelig standardstatistikk',
  },
  collection: {
    'en-us': 'Collection',
    'ru-ru': 'Коллекция',
    'es-es': 'Colección',
    'de-ch': 'Sammlung',
    'fr-fr': 'Collection',
    'pt-br': 'Coleção',
    'uk-ua': 'Колекція',
    'hr-hr': 'Kolekcija',
    nb: 'Samling',
  },
  personal: {
    'en-us': 'Personal',
    'ru-ru': 'Личный',
    'es-es': 'Personal',
    'de-ch': 'Persönlich',
    'fr-fr': 'Espace personnel',
    'pt-br': 'Pessoal',
    'uk-ua': 'Особисте',
    'hr-hr': 'Osobno',
    nb: 'Personlig',
  },
  private: {
    'en-us': 'Private',
    'es-es': 'Privado',
    'de-ch': 'Privat',
    'fr-fr': 'Privé',
    'pt-br': 'Privado',
    'ru-ru': 'Частный',
    'uk-ua': 'Приватний',
    'hr-hr': 'Privatno',
    nb: 'Privat',
  },
  collectionObjectsCataloged: {
    'en-us': 'Collection Objects Cataloged',
    'ru-ru': 'Объекты коллекции каталогизированы',
    'es-es': 'Objetos de la Colección Catalogados',
    'de-ch': 'Katalogisierte Sammlungsobjekte',
    'fr-fr': 'Objets informatisés',
    'pt-br': 'Objetos da Coleção Catalogados',
    'uk-ua': "Каталогізовані об'єкти колекції",
    'hr-hr': 'Katalogizirani objekti zbirke',
    nb: 'Antall samlingsobjekter registert',
  },
  collectionObjectsDetermined: {
    'en-us': 'Collection Objects Determined',
    'ru-ru': 'Объекты коллекции определены',
    'es-es': 'Objetos de la Colección Determinados',
    'de-ch': 'Sammlungsobjekte ermittelt',
    'fr-fr': 'Objets de la collection déterminés',
    'pt-br': 'Objetos da Coleção Determinados',
    'uk-ua': "Визначено об'єкти колекції",
    'hr-hr': 'Određeni objekti zbirke',
    nb: 'Antall samlingsobjekter identifisert',
  },
  lastRefreshed: {
    'en-us': 'Last refreshed',
    'es-es': 'Última Actualización',
    'de-ch': 'Zuletzt aktualisiert',
    'fr-fr': 'Dernière mise à jour',
    'pt-br': 'Última atualização',
    'ru-ru': 'Последнее обновление',
    'uk-ua': 'Останнє оновлення',
    'hr-hr': 'Zadnje osvježeno',
    nb: 'Sist oppdatert',
  },
  categoryName: {
    'en-us': 'Category Name',
    'ru-ru': 'Название категории',
    'es-es': 'Nombre de la Categoría',
    'de-ch': 'Kategoriename',
    'fr-fr': 'Nom de la catégorie',
    'pt-br': 'Nome da categoria',
    'uk-ua': 'Назва категорії',
    'hr-hr': 'Naziv kategorije',
    nb: 'Kategorinavn',
  },
  itemName: {
    'en-us': 'Item Name',
    'ru-ru': 'Название предмета',
    'es-es': 'Nombre del Item',
    'de-ch': 'Artikelname',
    'fr-fr': "Nom de l'article",
    'pt-br': 'Nome do item',
    'uk-ua': 'Назва елемента',
    'hr-hr': 'Naziv stavke',
    nb: 'Varenavn',
  },
  itemValue: {
    'en-us': 'Item Value',
    'ru-ru': 'Стоимость товара',
    'es-es': 'Valor del Ítem',
    'de-ch': 'Wert des Artikels',
    'fr-fr': "Valeur de l'article",
    'pt-br': 'Valor do item',
    'uk-ua': 'Значення елемента',
    'hr-hr': 'Vrijednost stavke',
    nb: 'Elementverdi',
  },
  downloadAsTSV: {
    'en-us': 'Download as TSV',
    'ru-ru': 'Скачать как TSV',
    'es-es': 'Descargar como TSV',
    'de-ch': 'Als TSV herunterladen',
    'fr-fr': 'Télécharger au format TSV',
    'pt-br': 'Baixar como TSV',
    'uk-ua': 'Завантажити як TSV',
    'hr-hr': 'Preuzmi kao TSV',
    nb: 'Last ned som TSV',
  },
  shared: {
    'en-us': 'Shared',
    'ru-ru': 'Общий',
    'es-es': 'Compartido',
    'de-ch': 'Gemeinsam',
    'fr-fr': 'Commun',
    'pt-br': 'Compartilhado',
    'uk-ua': 'Спільний доступ',
    'hr-hr': 'Dijeljeno',
    nb: 'Delt',
  },
  statistics: {
    'en-us': 'Statistics',
    'es-es': 'Estadísticas',
    'de-ch': 'Statistiken',
    'fr-fr': 'Statistiques',
    'pt-br': 'Estatísticas',
    'ru-ru': 'Статистика',
    'uk-ua': 'Статистика',
    'hr-hr': 'Statistika',
    nb: 'Statistikk',
  },
  deleteCategory: {
    'en-us': 'Delete Category',
    'es-es': 'Eliminar Categoría',
    'de-ch': 'Kategorie löschen',
    'fr-fr': 'Supprimer la catégorie',
    'pt-br': 'Excluir categoria',
    'ru-ru': 'Удалить категорию',
    'uk-ua': 'Видалити категорію',
    'hr-hr': 'Izbriši kategoriju',
    nb: 'Slett kategori',
  },
  editPage: {
    'en-us': 'Edit Page',
    'es-es': 'Editar Página',
    'de-ch': 'Seite bearbeiten',
    'fr-fr': 'Modifier la page',
    'pt-br': 'Editar página',
    'ru-ru': 'Редактировать страницу',
    'uk-ua': 'Редагувати сторінку',
    'hr-hr': 'Uredi stranicu',
    nb: 'Rediger side',
  },
  addPage: {
    'en-us': 'Add Page',
    'es-es': 'Agregar Página',
    'de-ch': 'Seite hinzufügen',
    'fr-fr': 'Ajouter une page',
    'pt-br': 'Adicionar página',
    'ru-ru': 'Добавить страницу',
    'uk-ua': 'Додати сторінку',
    'hr-hr': 'Dodaj stranicu',
    nb: 'Legg til side',
  },
  addACategory: {
    'en-us': 'Add a Category',
    'es-es': 'Agregar una Categoría',
    'de-ch': 'Kategorie hinzufügen',
    'fr-fr': 'Ajouter une catégorie',
    'pt-br': 'Adicionar uma categoria',
    'ru-ru': 'Добавить категорию',
    'uk-ua': 'Додати категорію',
    'hr-hr': 'Dodaj kategoriju',
    nb: 'Legg til en kategori',
  },
  refresh: {
    'en-us': 'Refresh',
    'es-es': 'Actualizar',
    'de-ch': 'Aktualisieren',
    'fr-fr': 'Rafraîchir',
    'pt-br': 'Atualizar',
    'ru-ru': 'Обновить',
    'uk-ua': 'Оновити',
    'hr-hr': 'Osvježiti',
    nb: 'Last inn på nytt',
  },
  collectionObjectsWithImages: {
    'en-us': 'Collection Objects with images',
    'es-es': 'Objetos de la Colección con imágenes',
    'de-ch': 'Sammlungsobjekte mit Bildern',
    'fr-fr': 'Objets de collection avec images',
    'pt-br': 'Objetos de coleção com imagens',
    'ru-ru': 'Коллекция объектов с изображениями',
    'uk-ua': "Об'єкти колекції із зображеннями",
    'hr-hr': 'Objekti kolekcije sa slikama',
    nb: 'Samlingsobjekter med bilder',
  },
  collectionObjectsWithAttachments: {
    'en-us': 'Collection Objects with attachments',
    'es-es': 'Objetos de la Colección con adjuntos',
    'de-ch': 'Sammlungsobjekte mit Anhängen',
    'fr-fr': 'Objets de collection avec pièces jointes',
    'pt-br': 'Objetos de coleção com anexos',
    'ru-ru': 'Объекты коллекции с вложениями',
    'uk-ua': "Об'єкти колекції з вкладеннями",
    'hr-hr': 'Objekti kolekcije s prilozima',
    nb: 'Samlingsobjekter med vedlegg',
  },
  error: {
    'en-us': 'Error',
    'es-es': 'Error',
    'de-ch': 'Fehler',
    'fr-fr': 'Erreur',
    'pt-br': 'Erro',
    'ru-ru': 'Ошибка',
    'uk-ua': 'Помилка',
    'hr-hr': 'Pogreška',
    nb: 'Feil',
  },
  taxonRepresented: {
    'en-us': 'Taxa Represented',
    'es-es': 'Taxones Representados',
    'de-ch': 'Vertretene Taxa',
    'fr-fr': 'Taxons représentés',
    'pt-br': 'Imposto Representado',
    'ru-ru': 'Представленные таксоны',
    'uk-ua': 'Представлені таксони',
    'hr-hr': 'Zastupljene taksone',
    nb: 'Taksa representert',
  },
  geographiesRepresented: {
    'en-us': 'Geographies Represented',
    'es-es': 'Geografías Representadas',
    'de-ch': 'Vertretene Regionen',
    'fr-fr': 'Lieux représentées',
    'pt-br': 'Geografias representadas',
    'ru-ru': 'Представленные географические регионы',
    'uk-ua': 'Представлені географічні регіони',
    'hr-hr': 'Zastupljena geografska područja',
    nb: 'Representerte geografiske områder',
  },
  percentGeoReferenced: {
    'en-us': 'Percent Georeferenced',
    'es-es': 'Porcentaje Georreferenciado',
    'de-ch': 'Prozent georeferenziert',
    'fr-fr': 'Pourcentage géoréférencé',
    'pt-br': 'Percentual georreferenciado',
    'ru-ru': 'Процент географически привязанных данных',
    'uk-ua': "Відсоток геоприв'язаних",
    'hr-hr': 'Postotak georeferenciranja',
    nb: 'Prosent med koordinater',
  },
  percentImaged: {
    'en-us': 'Percent Imaged',
    'es-es': 'Porcentaje Capturado',
    'de-ch': 'Prozent der abgebildeten',
    'fr-fr': "Pourcentage d'images",
    'pt-br': 'Percentual de imagens',
    'ru-ru': 'Процент изображений',
    'uk-ua': 'Відсоток зображень',
    'hr-hr': 'Postotak snimljenih',
    nb: 'Prosent avbildet',
  },
  deleteWarning: {
    'en-us': 'Are you sure you want to delete the category?',
    'de-ch': 'Möchten Sie die Kategorie wirklich löschen?',
    'es-es': '¿Estás seguro de que quieres eliminar la categoría?',
    'fr-fr': 'Êtes-vous sûr de vouloir supprimer cette catégorie ?',
    'pt-br': 'Tem certeza de que deseja excluir a categoria?',
    'ru-ru': 'Вы уверены, что хотите удалить категорию?',
    'uk-ua': 'Ви впевнені, що хочете видалити категорію?',
    'hr-hr': 'Jeste li sigurni da želite izbrisati kategoriju?',
    nb: 'Er du sikker på at du vil slette kategorien?',
  },
  categoryToDelete: {
    'en-us': 'This will permanently delete the following category',
    'de-ch': 'Dadurch wird die folgende Kategorie dauerhaft gelöscht.',
    'es-es': 'Esto eliminará permanentemente la siguiente categoría.',
    'fr-fr': 'Cela supprimera définitivement la catégorie suivante',
    'pt-br': 'Isso excluirá permanentemente a seguinte categoria.',
    'ru-ru': 'Это навсегда удалит следующую категорию.',
    'uk-ua': 'Це остаточно видалить наступну категорію',
    'hr-hr': 'Ovim će se trajno izbrisati sljedeća kategorija',
    nb: 'Dette vil slette følgende kategori permanent',
  },
  layoutPreference: {
    'en-us': 'Defines the layout of the statistics page',
    'de-ch': 'Definiert das Layout der Statistikseite',
    'es-es': 'Define el diseño de la página de estadísticas.',
    'fr-fr': 'Définit la mise en page de la page de statistiques',
    'pt-br': 'Define o layout da página de estatísticas.',
    'ru-ru': 'Определяет структуру страницы статистики.',
    'uk-ua': 'Визначає макет сторінки статистики',
    'hr-hr': 'Definira izgled stranice sa statistikom',
    nb: 'Definerer oppsettet til statistikksiden',
  },
  showPreparationsTotal: {
    'en-us': 'Show {preparationTableName:string} Totals',
    'de-ch': 'Summen anzeigen {preparationTableName:string}',
    'es-es': 'Mostrar totales {preparationTableName:string}',
    'fr-fr': 'Afficher les totaux {preparationTableName:string}',
    'pt-br': 'Mostrar totais {preparationTableName:string}',
    'ru-ru': 'Показать {preparationTableName:string} Итоги',
    'uk-ua': 'Показати {preparationTableName:string} підсумки',
    'hr-hr': 'Prikaži {preparationTableName:string} ukupne iznose',
    nb: 'Vis {preparationTableName:string} Antall',
  },
  showPreparationsTotalDescription: {
    'en-us':
      'If enabled, the default {preparationTableName:string} statistics panel will include a total count for each {lowerPreparationTableName:string} of a particular {prepTypeTableName:string} alongside the overall total. This is useful for lot-based collections.',
    'de-ch':
      'Ist diese Option aktiviert, zeigt das Standard-Statistikfeld {preparationTableName:string} neben der Gesamtanzahl auch die Gesamtzahl für jedes {lowerPreparationTableName:string} eines bestimmten {prepTypeTableName:string} an. Dies ist nützlich für chargenbasierte Sammlungen.',
    'es-es':
      'Si está habilitado, el panel de estadísticas predeterminado {preparationTableName:string} incluirá un recuento total para cada {lowerPreparationTableName:string} de un {prepTypeTableName:string} en particular junto con el total general. Esto es útil para colecciones basadas en lotes.',
    'fr-fr':
      "Si cette option est activée, le panneau de statistiques par défaut {preparationTableName:string} affichera le nombre total pour chaque {lowerPreparationTableName:string} d'un {prepTypeTableName:string} donné, ainsi que le total général. Ceci est utile pour les collections utilisant le concept de lot.",
    'pt-br':
      'Se ativado, o painel de estatísticas padrão {preparationTableName:string} incluirá uma contagem total para cada {lowerPreparationTableName:string} de um determinado {prepTypeTableName:string}, juntamente com o total geral. Isso é útil para coleções baseadas em lotes.',
    'ru-ru':
      'Если эта функция включена, на панели статистики {preparationTableName:string} по умолчанию будет отображаться общее количество для каждого {lowerPreparationTableName:string} конкретного {prepTypeTableName:string} наряду с общим итогом. Это полезно для коллекций, основанных на партиях.',
    'uk-ua':
      'Якщо ввімкнено, панель статистики {preparationTableName:string} за замовчуванням включатиме загальну кількість для кожного {lowerPreparationTableName:string} конкретного {prepTypeTableName:string} поряд із загальною сумою. Це корисно для колекцій на основі лотів.',
    'hr-hr':
      'Ako je omogućeno, zadana ploča sa statistikom {preparationTableName:string} uključivat će ukupan broj za svaki {lowerPreparationTableName:string} određenog {prepTypeTableName:string} uz ukupan zbroj. Ovo je korisno za kolekcije temeljene na lotovima.',
    nb: 'Hvis aktivert, vil standardstatistikkpanelet {preparationTableName:string} inkludere et totalt antall for hver {lowerPreparationTableName:string} av en bestemt {prepTypeTableName:string} sammen med den totale summen. Dette er nyttig for bulkbaserte samlinger.',
  },
  autoRefreshRate: {
    'en-us': 'Auto-Refresh Rate (Hours)',
    'de-ch': 'Automatische Aktualisierungsrate (Stunden)',
    'es-es': 'Frecuencia de actualización automática (horas)',
    'fr-fr': "Fréquence d'actualisation automatique (heures)",
    'pt-br': 'Taxa de atualização automática (horas)',
    'ru-ru': 'Частота автоматического обновления (в часах)',
    'uk-ua': 'Частота автоматичного оновлення (години)',
    'hr-hr': 'Brzina automatskog osvježavanja (sati)',
    nb: 'Automatisk oppdateringsfrekvens (timer)',
  },
  autoRefreshRateDescription: {
    'en-us':
      'The time interval, in hours, at which the statistics page will automatically refresh its data. Default is 24.',
    'de-ch':
      'Das Zeitintervall in Stunden, in dem die Statistikseite ihre Daten automatisch aktualisiert. Standardwert: 24.',
    'es-es':
      'El intervalo de tiempo, en horas, en el que la página de estadísticas actualizará automáticamente sus datos. El valor predeterminado es 24.',
    'fr-fr':
      'Intervalle de temps, en heures, auquel la page de statistiques actualise automatiquement ses données. La valeur par défaut est de 24 heures.',
    'pt-br':
      'O intervalo de tempo, em horas, no qual a página de estatísticas atualizará automaticamente seus dados. O padrão é 24.',
    'ru-ru':
      'Интервал времени в часах, через который страница статистики будет автоматически обновлять данные. Значение по умолчанию — 24.',
    'uk-ua':
      'Інтервал часу в годинах, через який сторінка статистики автоматично оновлюватиме свої дані. Значення за замовчуванням – 24.',
    'hr-hr':
      'Vremenski interval, u satima, u kojem će stranica sa statistikom automatski osvježiti svoje podatke. Zadana vrijednost je 24.',
    nb: 'Tidsintervallet, i timer, for hvor ofte statistikksiden automatisk oppdaterer dataene. Standard er 24.',
  },
} as const);
/* eslint-enable @typescript-eslint/naming-convention */
